var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-warning m-0"},[_vm._v(" Bu kural her zaman "),_c('u',[_vm._v("doğru (true)")]),_vm._v(" olarak döner. Eğer sadece "),_c('b',[_vm._v("x olduğu zaman")]),_vm._v(" kuralın geçmesini istiyorsanız kullanabilirsiniz. Yani bu kural geçersiz elemandır. ")])
}]

export { render, staticRenderFns }